import React, { useEffect, useState } from 'react';
import classname from 'classnames';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { LinkElement } from '@els/els-react--link-element';
import { useDispatch } from 'react-redux';
import { Icon } from '@els/els-react--icon';
import NodeRenderer from '../NodeRenderer';
import useFetchOperatorData from './hooks/useFetchOperator';
import useFetchBoundOps from './hooks/useFetchBoundOps';
import { addToBuilderAction } from '../QueryletActions';

function QueryPanel({ nodesList, onToggleQuerylet }) {
  const { operators } = useFetchOperatorData();
  const { boundOps } = useFetchBoundOps();
  const dispatch = useDispatch();
  const [isformNode, setFormNode] = useState(false);
  const formInfoText =
    'Completing all fields in the form is not necessary. Please ensure that at least one field is filled to start your search';

  const [, dropRef] = useDrop({
    accept: 'DragNode',
    drop: (item, monitor) => {
      if (monitor.didDrop()) return;
      dispatch(addToBuilderAction(item.node, 'default'));
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  useEffect(() => {
    const checkIfForm = nodesList.filter((node) => node.trackingSearchType && node.trackingSearchType[0] === 'forms');
    setFormNode(checkIfForm.length > 0);
  }, [nodesList]);

  return (
    <div id="main-content" className={classname('query-builder__container', { 'not-empty': nodesList.length > 0 })} ref={dropRef}>
      {nodesList.length === 0 && (
        <div className="query-builder__properties__placeholder">
          <div className="query-builder__properties__placeholder__no-title">
            <h3>There are no queries yet.</h3>
            <p>
              To build a new query, select fields and/or forms from the right panel by clicking on them or by dragging and dropping them
              here.
            </p>
            <LinkElement
              href="https://service.elsevier.com/app/answers/detail/a_id/11661/supporthub/reaxys/kw/query+builder/"
              isExternal
              iconSprite="UpRight"
              iconRight>
              Learn More
            </LinkElement>
          </div>
        </div>
      )}

      {nodesList.length > 0 && boundOps && boundOps.data && operators && (
        <div className="query-builder__properties drop-place">
          {isformNode && (
            <Icon
              sprite="InformationOutlineCircle"
              isVisible
              a11y={{
                name: 'Information',
                description: formInfoText,
              }}>
              {formInfoText}
            </Icon>
          )}
          {nodesList.map((property, index) => (
            <div className="ql__container" key={`querypanel-${property.uuid}`}>
              <NodeRenderer
                index={index}
                node={property}
                boundOps={boundOps}
                nodesList={nodesList}
                onToggleQuerylet={onToggleQuerylet}
                type="Node"
                operators={operators}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

QueryPanel.propTypes = {
  nodesList: PropTypes.array,
  onToggleQuerylet: PropTypes.func,
};

export default QueryPanel;
